import { styled, Box } from '@mui/material';

export const ResizeHandle = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 0, // Position exactly at the edge
  top: 0, // Full height alignment
  bottom: 0, // Full height alignment
  width: 4, // Clickable area width
  cursor: 'col-resize',
  backgroundColor: 'transparent',
  zIndex: 10,
  transition: 'background-color 0.2s ease',
  // Always visible vertical line
  '&::before': {
    content: '""',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '1px',
    backgroundColor: theme.palette.divider,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    '&::before': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&.dragging': {
    backgroundColor: theme.palette.action.selected,
    '&::before': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

export const ResizableContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
});
